import http from './http'

// 静默注册 / 登录（DeviceID）
export const registerWithDeviceId = (deviceId) => {
  return http.post('/api/user/login/device', { deviceId: deviceId })
}

// 第三方账号登录（Facebook/Google）
export const loginWithThirdParty = (loginFrom, oauthToken, deviceId) => {
  const data = {
    loginFrom: loginFrom,
    oauthToken: oauthToken,
    deviceId: deviceId
  }
  return http.post('/api/user/login/oauth', data)
}

// 获取当前用户信息
export const getUserInfo = (uid) => {
  return http.get('/api/user/info', { uid: uid })
}

// 获取当前用户信息
export const getWatchHistory = (uid, page, pageSize) => {
  const data = {
    uid: uid,
    page: page,
    pageSize: pageSize
  }
  return http.get('/api/user/watchHistory', data)
}

// 获取已购买/解锁的短剧
export const getMyDrama = (uid) => {
  const data = {
    uid: uid
  }
  return http.get('/api/user/myDramas', { data })
}
